// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2fdhj","content":"GlobalSearch_content__305kR"};